/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateReceiptPayloadDto,
  ErrorResponse,
  ReceiptBankAccountResponseDto,
  ReceiptFilterQueryDto,
  ReceiptPaginationResponseDto,
  ReceiptResponseDto,
  ReceiptSourceBrokerResponseDto,
  UpdateReceiptPayloadDto,
} from '../models/index';
import {
    CreateReceiptPayloadDtoFromJSON,
    CreateReceiptPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ReceiptBankAccountResponseDtoFromJSON,
    ReceiptBankAccountResponseDtoToJSON,
    ReceiptFilterQueryDtoFromJSON,
    ReceiptFilterQueryDtoToJSON,
    ReceiptPaginationResponseDtoFromJSON,
    ReceiptPaginationResponseDtoToJSON,
    ReceiptResponseDtoFromJSON,
    ReceiptResponseDtoToJSON,
    ReceiptSourceBrokerResponseDtoFromJSON,
    ReceiptSourceBrokerResponseDtoToJSON,
    UpdateReceiptPayloadDtoFromJSON,
    UpdateReceiptPayloadDtoToJSON,
} from '../models/index';

export interface CreateReceiptRequest {
    createReceiptPayloadDto: CreateReceiptPayloadDto;
}

export interface DeleteReceiptByIdRequest {
    receiptId: number;
}

export interface FilterReceiptsRequest {
    receiptFilterQueryDto: ReceiptFilterQueryDto;
    page?: number;
    pageSize?: number;
}

export interface GetReceiptByIdRequest {
    receiptId: number;
}

export interface UpdateReceiptByIdRequest {
    receiptId: number;
    updateReceiptPayloadDto: UpdateReceiptPayloadDto;
}

/**
 * 
 */
export class ReceiptApi extends runtime.BaseAPI {

    /**
     * Create receipt
     */
    async createReceiptRaw(requestParameters: CreateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceiptResponseDto>> {
        if (requestParameters['createReceiptPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createReceiptPayloadDto',
                'Required parameter "createReceiptPayloadDto" was null or undefined when calling createReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReceiptPayloadDtoToJSON(requestParameters['createReceiptPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceiptResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create receipt
     */
    async createReceipt(requestParameters: CreateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceiptResponseDto> {
        const response = await this.createReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete receipt by ID
     */
    async deleteReceiptByIdRaw(requestParameters: DeleteReceiptByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['receiptId'] == null) {
            throw new runtime.RequiredError(
                'receiptId',
                'Required parameter "receiptId" was null or undefined when calling deleteReceiptById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/{receiptId}`.replace(`{${"receiptId"}}`, encodeURIComponent(String(requestParameters['receiptId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete receipt by ID
     */
    async deleteReceiptById(requestParameters: DeleteReceiptByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteReceiptByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Filter receipts
     */
    async filterReceiptsRaw(requestParameters: FilterReceiptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceiptPaginationResponseDto>> {
        if (requestParameters['receiptFilterQueryDto'] == null) {
            throw new runtime.RequiredError(
                'receiptFilterQueryDto',
                'Required parameter "receiptFilterQueryDto" was null or undefined when calling filterReceipts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReceiptFilterQueryDtoToJSON(requestParameters['receiptFilterQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceiptPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter receipts
     */
    async filterReceipts(requestParameters: FilterReceiptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceiptPaginationResponseDto> {
        const response = await this.filterReceiptsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get receipt bank accounts
     */
    async getReceiptBankAccountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReceiptBankAccountResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/bank-accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReceiptBankAccountResponseDtoFromJSON));
    }

    /**
     * Get receipt bank accounts
     */
    async getReceiptBankAccounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReceiptBankAccountResponseDto>> {
        const response = await this.getReceiptBankAccountsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get receipt by ID
     */
    async getReceiptByIdRaw(requestParameters: GetReceiptByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceiptResponseDto>> {
        if (requestParameters['receiptId'] == null) {
            throw new runtime.RequiredError(
                'receiptId',
                'Required parameter "receiptId" was null or undefined when calling getReceiptById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/{receiptId}`.replace(`{${"receiptId"}}`, encodeURIComponent(String(requestParameters['receiptId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceiptResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get receipt by ID
     */
    async getReceiptById(requestParameters: GetReceiptByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceiptResponseDto> {
        const response = await this.getReceiptByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get receipt currencies
     */
    async getReceiptCurrenciesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/currencies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get receipt currencies
     */
    async getReceiptCurrencies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getReceiptCurrenciesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get receipt source brokers
     */
    async getReceiptSourceBrokersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReceiptSourceBrokerResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/source-brokers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReceiptSourceBrokerResponseDtoFromJSON));
    }

    /**
     * Get receipt source brokers
     */
    async getReceiptSourceBrokers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReceiptSourceBrokerResponseDto>> {
        const response = await this.getReceiptSourceBrokersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update receipt by ID
     */
    async updateReceiptByIdRaw(requestParameters: UpdateReceiptByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceiptResponseDto>> {
        if (requestParameters['receiptId'] == null) {
            throw new runtime.RequiredError(
                'receiptId',
                'Required parameter "receiptId" was null or undefined when calling updateReceiptById().'
            );
        }

        if (requestParameters['updateReceiptPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateReceiptPayloadDto',
                'Required parameter "updateReceiptPayloadDto" was null or undefined when calling updateReceiptById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/{receiptId}`.replace(`{${"receiptId"}}`, encodeURIComponent(String(requestParameters['receiptId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReceiptPayloadDtoToJSON(requestParameters['updateReceiptPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceiptResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update receipt by ID
     */
    async updateReceiptById(requestParameters: UpdateReceiptByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceiptResponseDto> {
        const response = await this.updateReceiptByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
